var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('ProformTable',{attrs:{"pevItem":_vm.pevItem,"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }